export default __webpack_public_path__ + "static/media/PG-Logo.f353b7bc.png";